import {
  FETCH_KEYS,
  FETCH_KEYS_ERROR,
  FETCH_FUTURE_KEYS,
  FETCH_FUTURE_KEYS_ERROR,
} from '../types';

const initialState = {
  spotKeys: [],
  futureKeys: [],
  success: false,
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_KEYS:
      return {
        ...state,
        spotKeys: action.payload,
        success: true,
        loading: false,
      };

    case FETCH_KEYS_ERROR:
      return {
        ...state,
        success: false,
        loading: true,
      };

    case FETCH_FUTURE_KEYS:
      return {
        ...state,
        futureKeys: action.payload,
        success: true,
        loading: false,
      };

    case FETCH_FUTURE_KEYS_ERROR:
      return {
        ...state,
        success: false,
        loading: true,
      };

    default:
      return state;
  }
}
